import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/login';
import SignUp from './components/Signup';
import ForgotPassword from './components/ForgotPassword';
import Dashboard from './Dashboard/Dashboard';
import MasterData from './pages/MasterData';
import ProductData from './pages/ProductData';
import ProductPassport from './pages/product-passport/ProductPassport';
import ProtectedRoute from './components/ProtectedRoute';
import TransactionalData from './pages/TransactionalData';
import Authenticator from './Dashboard/Authenticator';
import LocationMaster from './pages/Locationmaster';
import RoleBasedAccess from './pages/role-based-access/Rolebasedaccess';
import Tracker from './Dashboard/Tracker';
import Callback from './components/Callback';
import DisassemblyInstructionsPage from './components/DisassemblyPDFUpload/DisassemblyInstructionsPage';
import LifecycleEventPage from './components/LifeCycleEvent/LifecycleEventPage';
import UploadData from './components/DisassemblyPDFUpload/UploadData';
import UploadData2 from './components/UploadData2';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/callback" element={<Callback />} />

        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/role-based-access" element={<ProtectedRoute><RoleBasedAccess /></ProtectedRoute>} />
        <Route path="/authenticator" element={<ProtectedRoute><Authenticator /></ProtectedRoute>} />
        <Route path="/master-data" element={<ProtectedRoute><MasterData /></ProtectedRoute>} />
        <Route path="/product-data" element={<ProtectedRoute><ProductData /></ProtectedRoute>} />
        <Route path="/transaction-data" element={<ProtectedRoute><TransactionalData /></ProtectedRoute>} />
        <Route path='/location-master' element={<ProtectedRoute><LocationMaster /></ProtectedRoute>} />
        <Route path="/product-passport/:id" element={<ProtectedRoute><ProductPassport /></ProtectedRoute>} />
        <Route path="/tracker/:id" element={<ProtectedRoute><Tracker /></ProtectedRoute>} /> 
        <Route path="/disassembly-instructions" element={<DisassemblyInstructionsPage />} />
        <Route path="/lifecycle-event/:dppId" element={<ProtectedRoute><LifecycleEventPage /></ProtectedRoute>} />
        <Route path="/upload-data" element={<ProtectedRoute><UploadData /></ProtectedRoute>} />
        <Route path="/upload-data-2" element={<ProtectedRoute><UploadData2 /></ProtectedRoute>}/>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;